export const tooltipGiftWidth = 260
export const winkService = 'wink'
export const profileTooltipComplaintId = 'profileTooltipComplaintId'
export const photoMenuTooltipId = 'photoMenuTooltipId'
export const pageServiceAlbums = 'albums'
